<template>
  <v-card>
    <v-card-title class="text_primary pb-2">
      {{ page_title }}

      <v-spacer></v-spacer>
      <v-btn class="white--text" color="#5087e6" @click="addHelpNote"> 新增 </v-btn>
    </v-card-title>

    <v-divider></v-divider>
    <v-row class="mt-1 mb-1 pr-3">
      <v-col cols="12" lg="8" md="12" xs="12">
        <v-card-text class="d-flex align-center justify-end pt-0 pr-0 pb-0">
          <v-text-field
            v-model="search"
            dense
            outlined
            append-icon="mdi-magnify"
            label="搜尋 顯示頁面 / 錨點"
            single-line
            hide-details
            @keypress.enter="searchKeyword(search)"
          ></v-text-field>
          <v-btn class="ml-3 btn_action btn_action_bg_linear" @click="searchKeyword(search)">
            <v-icon> mdi-magnify </v-icon>
          </v-btn>
        </v-card-text>
      </v-col>
    </v-row>
    <v-divider></v-divider>
    <v-data-table :headers="headers" :items="items" :items-per-page="10" hide-default-footer>
      <template #[`item.actions`]="{ item }">
        <v-btn class="text_default btn_default btn_default_bg_linear mr-3" outlined @click="addHelpNote(item)">
          編輯
        </v-btn>

        <v-btn class="btn-danger white--text" outlined @click="disableLink(item)"> 刪除 </v-btn>
      </template>
    </v-data-table>

    <v-dialog v-if="add_dialog.is_show" v-model="add_dialog.is_show" width="700" @click:outside="closeDialog">
      <v-card>
        <v-card-title class="text-h5 white--text" style="background-color: #5087e6"> 提示設定 </v-card-title>

        <v-card-text class="pl-5 pr-5 mt-6 mb-3 pb-0">
          <v-form ref="form" lazy-validation @submit.prevent>
            <v-row v-for="(field, idx) in add_dialog.fields" :key="idx">
              <v-col cols="12" class="pt-0 pb-0">
                <h4>{{ field.name }}<span v-if="field.is_required" class="ml-1 red--text">(必填)</span></h4>
                <v-text-field
                  v-model="field.value"
                  dense
                  outlined
                  :rules="settingFormInputRules(field)"
                  :placeholder="field.placeholder"
                  @change="changeValueFormat(field)"
                />
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey" text @click="closeDialog"> 取消 </v-btn>
          <v-btn :color="'info'" text @click="submit"> 確定 </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <div class="text-center mt-5">
      <Pagination v-if="page_setting.is_show" :setting="page_setting" @changePage="changePage" />
    </div>
  </v-card>
</template>

<script>
import Pagination from '@/components/Utils/Pagination.vue'
import { apiGetReadmeMap, apiCreateReadmeMap, apiUpdateReadmeMap } from '@/api/admin.js'

export default {
  name: 'ReadmeMap',
  components: {
    Pagination,
  },
  data: function () {
    return {
      // 頁面名稱
      page_title: '功能提示',

      // items
      items: [],

      headers: [
        { text: '提示文字', value: 'help_note', sortable: false },
        { text: '錨點文字', value: 'trigger_anchor', sortable: false },
        { text: '顯示頁面', value: 'trigger_link', sortable: false },
        { text: '', value: 'actions', sortable: false },
      ],

      search: '',

      page_setting: {
        is_show: false,
        selected_page: 1,
        total_page: 10,
        total_visible: 10,
      },
      add_dialog: {
        is_show: false,
        copy: null,
        fields: [
          {
            name: '提示文字',
            value: '',
            id: 'help_note',
            is_required: true,
            placeholder: '滑鼠移上去問號要顯示的文字，例如: 實驗說明',
          },
          {
            name: '顯示頁面',
            value: '',
            id: 'trigger_link',
            is_required: true,
            check_domain: true,
            placeholder: '問號要顯示的頁面，例如: /optimize_page/experiments/',
          },
          {
            name: '錨點文字',
            value: '',
            id: 'trigger_anchor',
            is_required: true,
            placeholder: '問號要顯示在頁面中的哪個文字後面，例如: 實驗',
          },
          {
            name: '說明連結',
            value: '',
            id: 'help_link',
            is_required: false,
            placeholder: '點擊後要前往的網頁連結',
          },
        ],
      },
    }
  },
  mounted: function () {
    this.getData()
  },
  methods: {
    changeValueFormat(input_data) {
      if (!input_data.value) { return }
      if (input_data.value.startsWith(process.env.VUE_APP_DOMAIN)) {
        input_data.value = this.changeShowPageValueFormat(input_data.value)
      }
    },
    settingFormInputRules(config) {
      // 有新規則要加放這
      const rule_type = {
        is_required: this.$utils.field_rules.required,
        check_domain: this.$utils.field_rules.checkDomain
      }
      const rules = []
      for (const key in config) {
        if (rule_type[key] && config[key]) {
          rules.push(rule_type[key])
        }
      }
      return rules
    },
    changeShowPageValueFormat(path) {
      if (!path) {
        return ''
      }
      const parts = path.split('/')
      let has_container_id = false
      for (const part of parts) {
        if (part.match('DV_')) {
          has_container_id = true
          break
        }
      }
      const new_path = (point) => `/${parts.slice(point).join('/')}`
      return has_container_id ? new_path(5) : new_path(4)
    },
    async getData() {
      // 先抓網址上的頁碼，沒有預設就帶1
      let page_idx = parseInt(this.$route.query.page) ? parseInt(this.$route.query.page) : 1
      let limit = parseInt(this.$route.query.limit) ? parseInt(this.$route.query.limit) : 10
      this.search = this.$route.query.keyword ? this.$route.query.keyword : ''
      console.log('page_idx', page_idx)
      console.log('limit', limit)
      if (isNaN(limit)) {
        limit = 10
      }

      if (isNaN(page_idx)) {
        page_idx = 1
      }

      try {
        let params = {
          page: page_idx,
          limit: limit,
          key: this.search,
          status: 1,
        }
        let result = await apiGetReadmeMap(params)
        console.log('result', result)
        this.items = result.content
        this.page_setting.selected_page = page_idx
        this.page_setting.total_page = result.totalPages
        this.page_setting.is_show = true
      } catch (error) {
        console.log('get_readme_error', error)
      }
    },
    async searchKeyword(keyword, page_idx) {
      console.log('keyword:', keyword)
      let query = this.$route.query
      let tmp_query = { ...query, limit: 10, page: page_idx ? page_idx : 1, keyword: keyword }
      console.log(tmp_query)
      try {
        await this.$router.push({ path: this.$route.path, query: tmp_query })
        this.getData()
      } catch (err) {
        console.log('ex')
        console.log('err.name', err.name)
        if (err.name !== 'NavigationDuplicated') {
          throw err
        }
      }
    },
    addHelpNote(item) {
      this.add_dialog.is_show = true
      if (item) {
        this.add_dialog.fields.forEach((field) => {
          field.value = item[field.id]
        })
      }
    },
    closeDialog() {
      this.add_dialog.is_show = false
      this.add_dialog.fields.forEach((field) => {
        field.value = ''
      })
    },
    async submit() {
      let is_pass = this.$refs.form.validate()
      console.log('is_pass', is_pass)

      if (!is_pass) {
        return
      }

      let field_map = {}
      this.add_dialog.fields.forEach((field) => {
        field_map[field.id] = field.value
      })

      try {
        let params = {
          name: field_map.help_note,
          position: '',
          language: 'zh-TW',
          memo: '',
          status: 1,
          trigger_link: this.changeShowPageValueFormat(field_map.trigger_link),
          trigger_anchor: field_map.trigger_anchor,
          add_column: '',
          help_note: field_map.help_note,
          help_link: field_map.help_link,
        }
        console.log('params', params)
        let result = await apiCreateReadmeMap(params)
        console.log('result', result)

        this.$root.vtoast.show({
          message: '新增成功！',
        })
        this.closeDialog()
        await this.getData()
      } catch (error) {
        console.log('add_error', error)
      }
    },
    async disableLink(item) {
      let is_confirm = confirm('確定是否刪除?')
      if (!is_confirm) {
        return
      }
      try {
        let params = item
        item.status = 0
        let result = await apiUpdateReadmeMap(params)
        console.log('result', result)
        this.$root.vtoast.show({
          message: '刪除成功！',
        })
        this.getData()
      } catch (error) {
        console.log('disabled_error', error)
        this.$root.vtoast.show({
          message: `刪除失敗，原因: ${error}`,
        })
      }
    },
    async changePage() {
      this.getData()
    },
  },
}
</script>
<style scoped>
h4 {
  color: #5b5b5b;
}
</style>
